import "./terms.css";
import React from "react";
import { useNavigate } from "react-router-dom";

const FavoritesPage = () => {
  const navigate = useNavigate();

  // const redirectToBack = () => {
  //   navigate(-1);
  // };

  return (
    <section id="terms" className="section">
      <div className="container terms_container">
        <div className="terms__page_wrapper">
          <div className="terms__page">
            <iframe
              src="https://ae.servicelands.com/msf/aidente/terms-en.html"
              title="Terms & Conditions"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: "none" }}
            >
              Your browser does not support iframes.
            </iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FavoritesPage;
